import {useState, useContext, useEffect} from 'react';
import {useDebounce, useToggle} from 'react-use';
import {useTransition, animated} from 'react-spring';
import SETTINGS from '../settings';

import log from 'loglevel';

import SitePlanContext from '../utils/siteplan-context';
import {ACTIONS} from '../utils/site-storage';

import {FA} from '../utils/font-awesome.js';

const Notes = props => {
  const sitePlanContext = useContext(SitePlanContext);

  const [show, toggleShow] = useToggle(localStorage.getItem('awi_shownotes'));

  useEffect(() => {
    localStorage.setItem('awi_shownotes', show ? '1' : '');
  }, [show]);

  const showTransition = useTransition(show, null, {
    config:SETTINGS.ANIMATION.DEFAULT,
    from:{width:0},
    enter:{width:320},
    leave:{width:0},
  });

  const updateNotes = val => {
    let updatedMeta = {...sitePlanContext.currentSite.meta};
    updatedMeta['notes'] = val;
    sitePlanContext.dispatch({
      type:ACTIONS.UPDATE_CONTENT,
      payload:{...sitePlanContext.currentSite, meta:updatedMeta}
    });
  }

  return (
    <>
      {showTransition.map(({item, key, props}) => {
        return item && <animated.div key={key} style={props} className="notes">
          <textarea name="" id="" cols="30" rows="10" placeholder={"Notepad for " + sitePlanContext.currentSite.meta.title} onChange={e => updateNotes(e.target.value)} value={sitePlanContext.currentSite.meta.notes || ''} />
        </animated.div>
      })}
      <div className="notes-toggle" onClick={toggleShow}>
        {show ? <><FA icon="window-minimize" /> Hide</> : <><FA icon="pencil-alt" /> Notes</>}
      </div>
    </>
  );
}

export default Notes;
